// Intent: [Conversion] [Journey] [SEO/GEO]
import React from "react";
import { Building2Icon, HammerIcon, HardHatIcon, MountainIcon, RulerIcon } from "lucide-react";
import { ButtonLink } from "../components/shared/ButtonLink";
import { PageHero } from "../components/shared/PageHero";
const directPaths = [{
  title: "Trades",
  copy: "For cabinet installers and trade customers preparing cabinetry jobs for their work.",
  prepare: "Have business details and project information ready.",
  href: "/register/trade/",
  action: "Choose Trades",
  icon: HammerIcon,
  tone: "bg-pfpc-navy text-pfpc-offwhite border-pfpc-navy"
}, {
  title: "Do It Yourself - Easy",
  copy: "For capable renovators planning and ordering cabinetry for their own project.",
  prepare: "Prepare room, appliance and cabinetry information before starting.",
  href: "/register/diy/",
  action: "Do It Yourself - Easy",
  icon: RulerIcon,
  tone: "bg-pfpc-offwhite text-pfpc-navy border-pfpc-orange"
}] as const;
const assistedPaths = [{
  title: "Builders",
  copy: "Discuss project-based cabinetry requirements with PFPC before choosing an account path.",
  icon: HardHatIcon
}, {
  title: "Multi-Residential",
  copy: "Start with a project enquiry so scope, room schedules and the appropriate next step can be discussed.",
  icon: Building2Icon
}, {
  title: "Mining & Resources",
  copy: "Send the prepared project information to PFPC before registration or ordering.",
  icon: MountainIcon
}] as const;
function WhoWeHelpPage() {
  return <main id="main-content" data-id="element-495" data-mp="qkfel0pdya0a">
      <PageHero eyebrow="Who we help" title="Register directly or discuss the project first." copy="Trades and DIY customers have direct pathways. Builders and larger project enquiries can speak with PFPC before choosing the next step." data-id="element-496" data-mp="vgcsl0d6f49w">
        <ButtonLink href="#direct-paths" data-id="element-497" data-mp="15ek77cjzta8q">Choose Your Path</ButtonLink>
      </PageHero>

      <section id="direct-paths" className="section-shell scroll-mt-24 bg-[#eceae4]" data-id="element-498" data-mp="328x0zca97p6t">
        <div className="container-shell" data-id="element-499" data-mp="377q5wgbh67vd">
          <p className="section-label text-pfpc-steel" data-id="element-500" data-mp="378jhbuldplju">Direct registration</p>
          <div className="mt-4 grid gap-4 lg:grid-cols-2" data-id="element-501" data-mp="2z6irtgryvduq">
            {directPaths.map(({
            title,
            copy,
            prepare,
            href,
            action,
            icon: Icon,
            tone
          }) => <article key={title} className={`flex min-h-[300px] flex-col rounded-xl border p-7 ${tone}`} data-id="element-502" data-mp="394pyn6sjkfj0">
                <Icon className="h-8 w-8 text-pfpc-orange" strokeWidth={1.8} data-id="element-503" data-mp="344u37vxwtwf2" />
                <h2 className="mt-7 font-heading text-[24px] font-extrabold" data-id="element-504" data-mp="3i4lg1tcox6rh">{title}</h2>
                <p className="mt-3 text-[15px] leading-6 opacity-75" data-id="element-505" data-mp="3d5rxvnmgkrkz">{copy}</p>
                <p className="mt-3 text-[13px] leading-5 opacity-60" data-id="element-506" data-mp="3d3pa7a8s3ajf">{prepare}</p>
                <ButtonLink href={href} variant={title === "Trades" ? "secondaryDark" : "primary"} className="mt-auto self-start" data-id="element-507" data-mp="3ru4ummtdeegj">{action}</ButtonLink>
              </article>)}
          </div>
        </div>
      </section>

      <section className="section-shell bg-pfpc-offwhite" data-id="element-508" data-mp="odac429xw1n">
        <div className="container-shell" data-id="element-509" data-mp="py43rgrlayg">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between" data-id="element-510" data-mp="jcnpu04cx3mg"><div data-id="element-511" data-mp="jakq2odejw4j"><p className="section-label text-pfpc-steel" data-id="element-512" data-mp="jaukco5hcpg1">Discuss the project first</p><h2 className="mt-2 font-heading text-[28px] font-extrabold text-pfpc-navy" data-id="element-513" data-mp="ob8jfgp3sp1x">Builder and larger project enquiries.</h2></div><ButtonLink href="/help/" variant="secondary" data-id="element-514" data-mp="aebslf8zj7l1">Contact PFPC</ButtonLink></div>
          <div className="mt-6 grid gap-3 md:grid-cols-3" data-id="element-515" data-mp="f9920na6fiyg">
            {assistedPaths.map(({
            title,
            copy,
            icon: Icon
          }) => <article key={title} className="rounded-xl border border-pfpc-navy/15 bg-[#eceae4] p-5" data-id="element-516" data-mp="5cw75m2waz24"><Icon className="h-6 w-6 text-pfpc-steel" strokeWidth={1.8} data-id="element-517" data-mp="5eqv799gr7af" /><h3 className="mt-5 font-heading text-lg font-extrabold text-pfpc-navy" data-id="element-518" data-mp="3ns6p265g429c">{title}</h3><p className="mt-2 text-[14px] leading-6 text-pfpc-navy/65" data-id="element-519" data-mp="3rtikisb03hpg">{copy}</p><a href="/help/" className="mt-4 inline-flex min-h-11 items-center text-[13px] font-bold text-pfpc-navy underline decoration-pfpc-orange underline-offset-4" data-id="element-520" data-mp="3dszetru0cnqg">Discuss your project →</a></article>)}
          </div>
        </div>
      </section>
    </main>;
}
export { WhoWeHelpPage };